import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/es'

// Registers dayJs plugins
dayjs.extend(timezone)
dayjs.extend(utc)

// const formatDB = 'YYYY-MM-DDTHH:mm:ss'

export default {
  parseDate (dateString) {
    return dayjs(dateString)
  },
  formatDate (date, format = 'YYYY-MM-DD') {
    if (!date) {
      return ''
    }

    if (date === '') {
      return date
    } else {
      if (typeof date === 'string') {
        date = this.parseDate(date)
      }
      return date.format(format)
    }
  },
  getCurrentDateDB () {
    // return dayjs().format(formatDB)
    return dayjs().toISOString()
  },
  add (date, field, value) {
    return this.parseDate(date).add(value, field)
  },
  now () {
    return dayjs()
  }
}
